import styled from 'styled-components';

const WraperWelcomBanner = styled.div`
  width: 362px;
  height: 100%;
  padding: 18px;
  border-radius: 8px;
  background:
    linear-gradient(
      180deg,
      rgba(27, 27, 27, 0) 54.21%,
      rgba(27, 27, 27, 0.72) 66.7%,
      #1b1b1b 100%
    ),
    url(<path-to-image>) lightgray 0px -108.87px / 100% 123.012% no-repeat;
  aspect-ratio: 83/141;
  z-index: 10;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 362px;
    border-radius: 8px;
    // height: 615px;
    aspect-ratio: 83/141;
    background-image: url(/images/icons/welcom_banner_signUp/pingwin-wellcom.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
`;

export { WraperWelcomBanner };
